// COMPONENT
import HeaderComponent from "../../components/Header"
import MenuComponent from "../../components/SideMenu"
import BreadcrumbComponent from "../../components/Breadcrumb"
import { format_date, loading } from "../../components/CustomComponent"

import PENDING from "../../components/image/pending.gif"
import PROCESS from "../../components/image/process.gif"
import SUCCESS from "../../components/image/success.gif"
import CANCEL from "../../components/image/cancel.gif"
import FIX from "../../components/image/fix.gif"
import WHEELCHAIR from "../../components/image/wheelchair.gif"
import EMERGENCY from "../../components/image/emergency.gif"

// LIBRARY
import Swal from "sweetalert2"
import { toast } from "react-toastify"
import Cookies from "universal-cookie"
import ReactLoading from "react-loading"
import React, { Component } from "react"
import Pagination from "react-js-pagination"
import { Slide } from "react-slideshow-image"
import DateRangePicker from "react-bootstrap-daterangepicker"

// CSS
import "../../components/css/style.css"
import "../../components/css/bootstrap.css"
import "react-slideshow-image/dist/styles.css"
import "bootstrap-daterangepicker/daterangepicker.css"

const cookies = new Cookies()
toast.configure()

let month_array = [
  "",
  "ม.ค.",
  "ก.พ.",
  "มี.ค.",
  "เม.ย.",
  "พ.ค.",
  "มิ.ย.",
  "ก.ค.",
  "ส.ค.",
  "ก.ย.",
  "ต.ค.",
  "พ.ย.",
  "ธ.ค.",
]
export default class InAndOutListScreen extends Component {
  constructor(props) {
      super(props)
      this.state = {
        loading: false,
        tab: false,

        modal_detail: false,
        modal_filter: false,

        filter_project: "",
        filter_agency: "",
        filter_status: "",
        filter_startdate: "",
        filter_enddate: "",
  
        token: cookies.get("token") ? "token " + cookies.get("token") : "",

        page: 1,
  
        project_all_list: cookies.get("user_profile")?.agency_list || [],
        agency_all_list: [],
        project_name_map: {},
      }
      this.interval = null;
    }
  
    componentDidMount() {
      const { project_all_list } = this.state;
      this.setState({ loading: true })
      this.GET();
      this.interval = setInterval(() => {
        this.GET();
      },10000);
      var user = cookies.get("user_profile")
      if (user.role_data.role_name === "system_admin") {
        this.get_Project()
      } else {
        this.get_ProjectNameMap()
        const profile = cookies.get("user_profile");

this.setState(prevState => {
  const exists = prevState.project_all_list.some(
    item => item.agency_id === profile?.agency_id
  );

  if (exists) {
    return null; // ❌ ไม่เพิ่ม ถ้ามีแล้ว
  }

  return {
    project_all_list: [
      ...prevState.project_all_list,
      {
        agency_id: profile?.agency_id,
        agency_name: profile?.agency_name,
        project_id: profile?.project_id,
        project_name: profile?.project_name,
      }
    ]
  };
});
 this.get_Agency(profile?.project_id)
      }
    }
    componentWillUnmount(){
    if (this.interval) {
      clearInterval(this.interval);
    }
  }
  
    alert(icon, title, detail, html, url) {
      return Swal.fire({
        icon: icon === "submit" ? "info" : icon,
        title,
        text: detail,
        html,
        confirmButtonText: icon === "submit" ? "ยืนยัน" : "ตกลง",
        showCancelButton: icon === "submit",
        cancelButtonText: "ยกเลิก"
      }).then(result => {
        if (url) {
          window.location.href = url;
        }
        return result.isConfirmed;
      });
    }
    GET() {
      const { tab, token, page, filter_project, filter_agency, filter_status, filter_startdate, filter_enddate } = this.state;
      
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
      }
      fetch(global.api + "v1/call-service/transaction?page="+ page +
      "&project_id="+filter_project+
      "&agency_id="+filter_agency+
      "&status="+(filter_status || (!tab ? "รอตอบรับ,รับงานแล้ว":""))+
      // "&status="+(filter_status || (!tab ? "":""))+
      "&start_date="+filter_startdate+
      "&end_date="+filter_enddate, requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            result.data.data = result.data.data.sort((a,b) => new Date(b.service_start_at).getTime() - new Date(a.service_start_at).getTime())
            this.setState({ data: result.data, loading: false })
            const last_service_time = localStorage.getItem("last_service_time");
            const last = result.data ? result.data.data[0] : null
            console.log("last:",last);
            if(last && last_service_time && Number(last_service_time) < new Date(last.service_start_at).getTime()){
              localStorage.setItem("last_service_time",new Date(last.service_start_at).getTime().toString());
              this.alert("info", "คำขอใหม่", "",`
                <h5 class="mb-0 fw-bold">คำขอ "${last?.service_name}"</h5>
                <h5 class="mb-2 fw-bold">กรุณาตรวจสอบและดำเนินการ</h5>
                <div class="text-secondary">Request ID:</div>
                <div class="fw-bold mb-3">${last?.running_number || ""}</div>
                <div class="d-flex justify-content-center mb-3">
                  <div class="mx-1">โครงการ</div> <div class="text-secondary fw-bold">${this.project_name_of(last)}</div>
                  <div class="mx-1">หน่วยงาน</div> <div class="text-secondary fw-bold">${last?.agency_name || ""}</div>
                </div>
              `,"")
            }
            if(!last_service_time){
              localStorage.setItem("last_service_time",new Date(last.service_start_at).getTime().toString());
            }
          } else {
            switch (result.data.status) {
              case "This Page is not available":
                this.setState({ data: [] })
                break
              default:
                this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ","","/")
                cookies.remove("token")
                break
            }
            this.setState({ loading: false })
          }
        })
        .catch((e) => {
          this.setState({ loading: false })
        })
    }
    get_Project() {
      this.setState({ loading: true })
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      }
      fetch(global.api + "v1/project/all", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            this.setState({ project_all_list: result.data.data })
            this.set_ProjectNameMap(result.data.data)
            this.setState({ loading: false })
          } else {
            switch (result.data.message) {
              case "":
                break
              default:
                this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
                cookies.remove("token")
                window.location.href = "/"
                break
            }
            this.setState({ loading: false })
          }
        })
        .catch((e) => {
          this.setState({ loading: false })
        })
    }
    // ชื่อโครงการที่ติดมากับรายการบริการบางรายการเป็นค่าเก่า (ได้ project_id มาแทนชื่อ)
    // จึงอ้างชื่อจากรายการโครงการหลัก (v1/project/all) โดยเทียบด้วย project_id
    set_ProjectNameMap(project_list) {
      const map = {}
      if (project_list) {
        project_list.forEach((item) => {
          if (item?.project_id && item?.project_name) {
            map[item.project_id] = item.project_name
          }
        })
      }
      this.setState({ project_name_map: map })
    }
    get_ProjectNameMap() {
      const requestOptions = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
      }
      fetch(global.api + "v1/project/all", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            this.set_ProjectNameMap(result.data.data)
          }
        })
        .catch((e) => {})
    }
    project_name_of(item) {
      return (
        this.state.project_name_map?.[item?.project_id] || item?.project_name || ""
      )
    }
    get_Agency(id) {
      this.setState({ loading: true })
      const requestOptions = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
        },
        body: JSON.stringify({
          project_id: id,
        }),
      }
      fetch(global.api + "v1/project/agency", requestOptions)
        .then((response) => response.json())
        .then((result) => {
          if (result.status) {
            this.setState({ agency_all_list: result.data.data })
            this.setState({ loading: false })
          } else {
            switch (result.data.message) {
              case "":
                break
              default:
                this.alert("info", "แจ้งเตือน", "เซสชันหมดอายุ")
                cookies.remove("token")
                window.location.href = "/"
                break
            }
            this.setState({ loading: false })
          }
        })
        .catch((e) => {
          this.setState({ loading: false })
        })
    }
    handlePageChange(pageNumber) {
      this.setState({ page: pageNumber, index: -1, loading: true, card_list: null },() => this.GET())
    }
    Edit = (status) => {
      const {token, description} = this.state;
      this.setState({ loading: true })
      const {uid} = this.state;
      const requestOptions = {
        method: "PUT",
        headers: {
          "Content-Type": "application/json",
          accept: "application/json",
          Authorization: token,
        },
        body: JSON.stringify({
          uid: uid,
          status,
          description,
          assignee_name: cookies.get("user_profile")?.full_name || ""
        }),
      }
      fetch(global.api + "v1/call-service/transaction/update", requestOptions)
        .then((response) => response.json())
        .then(async (result) => {
          if (result.status) {
            this.alert("success", "สำเร็จ", "ทำรายการสำเร็จแล้ว")
            await this.clear_form();
            this.GET()
          } else {
            this.alert("info", "แจ้งเตือน", "เกิดข้อผิดพลาด")
            this.setState({ loading: false })
          }
        })
        .catch((e) => {
          this.setState({ loading: false })
        })
    }
    clear_form() {
      this.setState({
        modal_add: false,
        modal_edit: false,
        modal_qrcode: false,
        card_list: null,
        uid: "",

        page: 1,
      })
    }
  render() {
    const { loading,tab, modal_detail, data, page, project_all_list, agency_all_list, filter_project, filter_agency, filter_status, filter_startdate, filter_enddate, modal_filter } = this.state;
    return (
      <div className="full bg-contain">
        {loading && (
          <div className="loading">
            <ReactLoading
              type={"spinningBubbles"}
              color="#fff"
              height={48}
              width={48}
            />
          </div>
        )}
        <div className="menu-container ">
          <MenuComponent />

          <div className="w-100 ">
            <BreadcrumbComponent
              page1="บริการ"
              page2="รายงานบริการ"
            />
            <HeaderComponent header={!tab ? "รายการคำขอ" : "รายงานบริการ"} report="true" />
            {/* เมนู ฟิลเตอร์  */}
            <div className="bg-gray px-3 pt-3 w-100">
              <div className="row d-flex flex-wrap mx-0 justify-content-between">
                <div className="d-flex flex-wrap mx-0">
                  {/* ตัวกรองโครงการ */}
                  <div className="mx-2 mb-3">
                    <button
                      className="btn btn-outline-primary bg-white "
                      onClick={() => {
                        this.setState({ modal_filter: true })
                      }}
                    >
                      <span className="icon mr-2">{"\uf1de"}</span>
                      ตัวกรองโครงการ
                    </button>
                    <div
                      class={modal_filter ? "bg-modal" : ""}
                      onClick={() => {
                        this.setState({ modal_filter: false })
                      }}
                    ></div>

                    {/* modal */}
                    <div
                      class={
                        modal_filter
                          ? "card border-0 modal-filter p-3 mt-3"
                          : "d-none"
                      }
                    >
                      {/* โครงการ */}
                      <div class="row my-2">
                        <div class="col-4">โครงการ:</div>
                        <div class="col-8">
                          <select
                            className="form-control"
                            value={filter_project}
                            onChange={(e) => {
                              this.setState({
                                filter_project: e.target.value,
                                filter_agency: "all",
                              },() =>  this.get_Agency(e.target.value))
                            }}
                          >
                            <option value="all" selected disabled>
                              -- เลือกโครงการ --
                            </option>
                            {project_all_list &&
                              project_all_list.map((item, index) => (
                                <option value={item.project_id} key={index}>
                                  {item.project_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>

                      {/* หน่วยงาน */}
                      <div class="row my-2">
                        <div class="col-4">หน่วยงาน:</div>
                        <div class="col-8">
                          <select
                            className="form-control"
                            value={filter_agency}
                            onChange={(e) => {
                              this.setState({ filter_agency: e.target.value })
                            }}
                          >
                            <option value="all" selected disabled>
                              -- เลือกหน่วยงาน --
                            </option>
                            {agency_all_list &&
                              agency_all_list.map((item, index) => (
                                <option value={item.agency_id} key={index}>
                                  {item.agency_name}
                                </option>
                              ))}
                          </select>
                        </div>
                      </div>
                      <hr class="my-1" />
                      {/* ปุ่ม */}
                      <div class="row my-2">
                        <div class="col-4"></div>
                        <div class="col-8 d-flex">
                          <button
                            className="btn btn-secondary mr-2 w-50"
                            onClick={() => {
                              this.setState({
                                filter_startdate: "",
                                filter_enddate: "",
                                filter_agency: "",
                                filter_project: "",
                                filter_status: "",
                                page: 1,
                              })

                              setTimeout(() => {
                                this.GET()
                              }, 10)

                              this.setState({
                                modal_filter: false,
                              })
                            }}
                          >
                            รีเซ็ท
                          </button>
                          <button
                            className="btn btn-primary ml-2 w-50"
                            onClick={() => {
                              this.setState({
                                page: 1,
                              })

                              setTimeout(() => {
                                this.GET()
                              }, 10)

                              this.setState({
                                modal_filter: false,
                              })
                            }}
                          >
                            <span className="icon mr-2">{"\uf1de"}</span>
                            ยืนยัน
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* สถานะ */}
                  <div className="mx-2 mb-3">
                    <select
                      className="form-control"
                      value={filter_status}
                      onChange={(e) => {
                        this.setState({
                          filter_status: e.target.value,
                          page: 1,
                        },() => {
this.GET()
                        })
                      }}
                    >
                      <option value="" selected>แสดงทุกสถานะ</option>
                      <option value="รอตอบรับ">รอตอบรับ</option>
                      <option value="รับงานแล้ว">รับงานแล้ว</option>
                      <option value="สำเร็จ">สำเร็จ</option>
                      <option value="ยกเลิก">ยกเลิก</option>
                    </select>
                  </div>

                  {/* วันที่ */}
                  <div className="mx-2 mb-3 w-250px">
                    <DateRangePicker
                      initialSettings={{
                        startDate: new Date(),
                        endDate: new Date(),
                        locale: {
                          format: "DD/MM/YYYY",
                        },
                      }}
                      onApply={(e) => {
                        let value = e.target.value
                        let start = value.split(" - ")[0]
                        let end = value.split(" - ")[1]
                        let startdate =
                          start.split("/")[2] +
                          "-" +
                          start.split("/")[1] +
                          "-" +
                          start.split("/")[0]
                        let enddate =
                          end.split("/")[2] +
                          "-" +
                          end.split("/")[1] +
                          "-" +
                          end.split("/")[0]

                        this.setState({
                          page: 1,
                          filter_startdate: startdate,
                          filter_enddate: enddate,
                        },() => {
this.GET()
                        })
                      }}
                    >
                      <input type="text" className="form-control " />
                    </DateRangePicker>
                  </div>
                   <button
                            className="btn btn-secondary mr-2 px-4"
                            onClick={() => {
                              this.setState({
                                filter_startdate: "",
                                filter_enddate: "",
                                filter_agency: "",
                                filter_project: "",
                                filter_status: "",
                                page: 1,
                              })

                              setTimeout(() => {
                                this.GET()
                              }, 10)

                              this.setState({
                                modal_filter: false,
                              })
                            }}
                          >
                            ล้างข้อมูล
                          </button>
                </div>
              </div>
            </div>
            <div className="px-3 pt-2">
              <button className={`btn btn-${!tab ? "primary" : "outline-primary"} px-3 mr-1`} onClick={() => { this.setState({ tab: false, data: null, loading: true },() => {this.GET(); this.interval = setInterval(() => {
        this.GET();
      },10000);}) }}>
                <span className="icon mr-2">{"\uf0f3"}</span>รายการคำขอ
              </button>
              <button className={`btn btn-${tab ? "primary" : "outline-primary"} px-3 mr-1`} onClick={() => { this.setState({ tab: true, data: null, loading: true },() => {this.GET(); if (this.interval) {
      clearInterval(this.interval);
    }}) }}>
                <span className="icon mr-2">{"\uf03a"}</span>รายงาน
              </button>
            </div>
            {!tab && (<div className="p-3">
               {data?.data?.map((item, index) => (
              <div className="bg-white p-3 rounded-1 mb-3">
                <div className="d-flex align-items-start justify-content-between">
                  <div className="d-flex flex-wrap">
                    <div className="bg-warning rounded-3 px-3 py-1 mr-2 mb-2 text-nowrap">REQ ID : {item.running_number}</div>
                    <div className="card rounded-3 px-3 py-1 mr-2 mb-2 text-nowrap">วันที่ {format_date(item.service_start_at,"dd/mm/yyyy hh:mm:ss")}</div>
                    <div className={`${item.service_name === "ต้องการรถรับส่ง" ? "bg-success text-white" : 
                  item.service_name === "ขอรถเข็นนั่ง รถเข็นของ" ? "bg-dark text-white" : 
                  item.service_name === "รถจอดกีดขวาง / รถสตาร์ทไม่ติด ต้องการความช่วยเหลือ" ? "bg-orange text-white" : 
                  item.service_name === "ขอความช่วยเหลือเร่งด่วน" ? "bg-danger text-white" : 
                  item.service_name === "ต้องการเจ้าหน้าที่เข็นรถ" ? "bg-success text-white" : 
                  item.service_name === "รถสตาร์ทไม่ติดต้องการความช่วยเหลือ" ? "bg-orange text-white" : 
                  null} rounded-3 px-3 py-1 mr-2 mb-2 text-nowrap fw-bold`}>{item.service_name || "-"}</div>
                  </div>
                  {item.status === "รอตอบรับ" ? (
                  <div className="bg-warning rounded-3 px-3 py-1 mr-2 text-dark mb-3 text-nowrap">รอตอบรับ</div>
                ) : (
                    <div className="bg-primary rounded-3 px-3 py-1 mr-2 text-white mb-3 text-nowrap">รับงานแล้ว</div>
                  )}
                </div>
                    <div className="d-flex align-items-center justify-content-between mb-3 flex-wrap">
                      <div>
                      <h5 className="fw-bold mr-3 mb-2">โครงการ : {this.project_name_of(item)}</h5>
                      <h5 className="fw-bold mr-3 mb-2">หน่วยงาน : {item.agency_name}</h5>
                      <h5 className="fw-bold mr-3 mb-2">ชื่อจุดสแกนคิวอาร์โค้ด : {item.name}</h5>
                      </div>
 <div className="rounded-circle d-flex align-items-center justify-content-center" style={{minWidth: 90, width: 90,height: 90, border: "3px solid #2f5597"}}>
                  <img src={item.service_name === "ต้องการรถรับส่ง" ? PROCESS : 
                  item.service_name === "ขอรถเข็นนั่ง รถเข็นของ" ? WHEELCHAIR : 
                  item.service_name === "รถจอดกีดขวาง / รถสตาร์ทไม่ติด ต้องการความช่วยเหลือ" ? FIX : 
                  item.service_name === "ขอความช่วยเหลือเร่งด่วน" ? EMERGENCY : 
                  item.service_name === "ต้องการเจ้าหน้าที่เข็นรถ" ? PROCESS : 
                  item.service_name === "รถสตาร์ทไม่ติดต้องการความช่วยเหลือ" ? FIX : 
                  null} alt="process" width={55} height={55} style={{}}/>
                </div> 
                    </div>
                    <span>หมายเหตุ : {item.description.split("|").filter(e=>e).map(e=>(<div>- {e.replaceAll(":"," : ")}</div>))}</span>
                     {!["สำเร็จ","ยกเลิก"].includes(item.status) && (
                     <div className="d-flex justify-content-between mt-3">
                    <button className="btn btn-link text-danger px-0" onClick={() => { 
                    Swal.fire({
                      icon: "info",
                      title: "ยกเลิกคำขอ",
                      text: `ยืนยันการ "ยกเลิกคำขอ" หรือไม่?`,
                      confirmButtonText: "ยกเลิกคำขอ",
                      showCancelButton: true,
                      cancelButtonText: "ปิดหน้าต่าง",
                      input: "textarea",
                      inputPlaceholder: "กรุณาระบุเหตุผลในการยกเลิกคำขอ...",
                      inputAttributes: {
                        "aria-label": "Cancellation reason"
                      },
                      inputValidator: value => {
                        if (!value) {
                          return "กรุณากรอกเหตุผลก่อนยกเลิกคำขอ";
                        }
                      }
                    }).then(result => {
                      if(result.isConfirmed){
                        const reason = result.value;
                        this.setState({...item, description: item.description + (reason ? ("|admin:" +reason) : "")},() => this.Edit("ยกเลิก"))
                        
                      }
                    });
                   }}>ยกเลิกคำขอ </button>

                  <button className="btn btn-primary px-3" onClick={() => { 
                    Swal.fire({
                      icon: "info",
                      title: "ยืนยัน",
                      text: `ยืนยันการ "${{"รอตอบรับ": "รับงาน","รับงานแล้ว": "ปิดงาน"}[item.status]}" หรือไม่?`,
                      confirmButtonText: {"รอตอบรับ": "รับงาน","รับงานแล้ว": "ปิดงาน"}[item.status],
                      showCancelButton: true,
                      cancelButtonText: "ปิดหน้าต่าง",
                      input: "textarea",
                      inputPlaceholder: "กรุณาระบุเหตุผลในการยกเลิกคำขอ...",
                      inputAttributes: {
                        "aria-label": "Cancellation reason"
                      },
                    }).then(result => {
                      if(result.isConfirmed){
                        const reason = result.value;
                        this.setState({...item, description: item.description + (reason ? ("|admin:" +reason) : "")},() => this.Edit({ "รอตอบรับ": "รับงานแล้ว", "รับงานแล้ว": "สำเร็จ"}[item.status]))
                      }
                    });
                   }}>
                {{
                  "รอตอบรับ": "รับงาน",
                  "รับงานแล้ว": "ปิดงาน",
                }[item.status]}
              </button>
              </div>
              )}
              </div>
               ))}
            </div>)}
            {tab && (<div>
              {/* ตาราง */}
              {data?.data?.length === 0 ? (
                <div className="w-100 p-3">
                  <div className="table-responsive">
                    <table className="table design-table">
                      <thead>
                        <tr>
                          <th className="text-left">REQ ID</th>
                          <th className="text-left">วันที่-เวลา</th>
                          <th className="text-left">ประเภทบริการ</th>
                          <th className="text-left">จุดบริการ</th>
                          <th className="text-left">รับเรื่อง</th>
                          <th className="text-center w-150px">สถานะ</th>
                          <th className="text-center">รายละเอียด</th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr>
                          <td colSpan={7} className="text-center">
                            ไม่มีข้อมูล
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              ) : (
                <div className="w-100 p-3">
                  <div className="table-responsive">
                    <table className="table design-table">
                      <thead>
                        <tr>
                          <th className="text-left">REQ ID</th>
                          <th className="text-left">วันที่-เวลา</th>
                          <th className="text-left">ประเภทบริการ</th>
                          <th className="text-left">จุดบริการ</th>
                          <th className="text-left">รับเรื่อง</th>
                          <th className="text-center w-150px">สถานะ</th>
                          <th className="text-center">รายละเอียด</th>
                        </tr>
                      </thead>
                      <tbody>
                        {data?.data?.map((item, index) => (
                            <tr>
                              <td>{item.running_number}</td>
                              <td>{format_date(item.service_start_at,"dd/mm/yyyy hh:mm:ss")}</td>
                              <td>{item.service_name}</td>
                              <td>{item.name}</td>
                              <td>{item.assignee_name}</td>
                              <td className="text-center">
                                {item.status === "สำเร็จ" && ( <span className="status bg-success text-light">สำเร็จ</span>)}
                                {item.status === "รอตอบรับ" && ( <span className="status bg-warning text-light">รอตอบรับ</span>)}
                                {item.status === "รับงานแล้ว" && ( <span className="status bg-primary text-light">รับงานแล้ว</span>)}
                                {item.status === "ยกเลิก" && ( <span className="status bg-danger text-light">ยกเลิก</span>)}
                              </td>
                              <td className="text-center">
                                <button
                                  className="btn btn-link"
                                  onClick={() => {
                                    this.setState({...item, project_name: this.project_name_of(item), modal_detail: true})
                                  }}
                                >
                                  <span className="icon mr-2">{"\uf06e"}</span>
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              )}
            </div>)}
            {/* pagination */}
            {this.state.data && (
              <div className="d-flex justify-content-between row mx-0 w-100 px-3">
                <div>
                  <span>
                    แสดง {this.state.data.end_index} จาก {this.state.data.count}{" "}
                    รายการ
                  </span>
                </div>
                <div className="d-flex">
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(1)
                    }}
                  >
                    <span className="icon">{"\uf100"}</span>
                  </button>
                  <Pagination
                    activePage={this.state.page}
                    itemsCountPerPage={10}
                    totalItemsCount={this.state.data.count}
                    pageRangeDisplayed={5}
                    onChange={this.handlePageChange.bind(this)}
                    prevPageText={<span className="icon">{"\uf104"}</span>}
                    nextPageText={<span className="icon">{"\uf105"}</span>}
                    hideFirstLastPages={true}
                  />
                  <button
                    className="btn-circle-white mx-1"
                    onClick={() => {
                      this.handlePageChange(this.state.data.page_number)
                    }}
                  >
                    <span className="icon">{"\uf101"}</span>
                  </button>
                </div>
              </div>
            )}
          </div>
        </div>
        {/* modal */}
        <div className={modal_detail ? "show-modal" : "hide-modal"}>
          <div className="w-100 h-100 position-absolute" onClick={() => {this.setState({ modal_detail: false })}}></div>
          <div className={modal_detail ? "box-modal p-4" : "hide-box-modal p-4"}>
            {/* ปุ่มปิด */}
            <div className="w-100">
              <button
                className="btn btn-link d-block d-md-none ml-auto"
                onClick={() => {
                  this.setState({ modal_detail: false })
                }}
              >
                <span className="icon mr-2 text-24">{"\uf00d"}</span>
              </button>
            </div>
            <div className="w-100">
              <h6 className="mb-1 text-center">Request ID</h6>
              <h2 className="mb-3 fw-bold text-center">{this.state.running_number}</h2>
              <hr/>
              <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 120}}>โครงการ: </div> {this.state.project_name}</h6>
              <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 120}}>หน่วยงาน: </div> {this.state.agency_name}</h6>
              <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 120}}>จุดบริการ: </div> {this.state.name}</h6>
              <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 120}}>เวลาที่แจ้ง: </div> {format_date(this.state.service_start_at, "dd/mm/yyyy hh:mm:ss")}</h6>
              <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 120}}>เวลาที่ปิดงาน: </div> {format_date(this.state.service_end_at, "dd/mm/yyyy hh:mm:ss")}</h6>
              <h6 className="d-flex mb-3"><div className="fw-bold" style={{width: 120}}>สถานะ: </div> {this.state.status}</h6>
            </div>
            <hr/>
            <h5 className="fw-bold mb-3">หมายเหตุ</h5>
             <div className="bg-light rounded-1 p-3 mb-3">
                  {this.state.description?.split("|")?.filter(e=>e).map(e=> {
                    if(!e){
                      return null;
                    }
                      if(e.startsWith("admin")){
                        return (
                          <div>
                            <div className="w-100 d-flex justify-content-end">
                          <small>admin</small>
                          </div>
                        <div className="d-flex justify-content-end mb-1">
                          <div className="rounded-1 shadow py-2 px-3 text-light" style={{maxWidth: "75%", backgroundColor: "#4c3bf9"}}>{e.split(":")[1]}</div>
                        </div>
                        </div>
                        )
                      }
                      else if(e.startsWith("suggestion")){
                        return (
                          <div className="d-flex justify-content-end mb-1">
                          <div className="rounded-1 shadow py-2 px-3 text-light" style={{maxWidth: "75%", backgroundColor: "#207724"}}>ข้อเสนอแนะ : {e.split(":")[1]}</div>
                        </div>
                        )
                      }
                      else if(e.startsWith("rate")){
                        return (
                          <div className="d-flex justify-content-end mb-1">
                          <div className="rounded-1 shadow py-2 px-3 text-light" style={{maxWidth: "75%", backgroundColor: "#207724"}}>ความพึงพอใจ : {e.split(":")[1]} คะแนน</div>
                        </div>
                        )
                      }
                      else{
                        return (
                          <div>
                            <div className="w-100 d-flex">
                          <small>user</small>
                          </div>
                          <div className="d-flex mb-1">
                          <div className="rounded-1 shadow py-2 px-3" style={{maxWidth: "75%", backgroundColor: "#ffffff"}}>{e.split(":")[1]}</div>
                        </div>
                        </div>
                        )
                      }
                    }
                  )}
                  </div>
          </div>
        </div>
      </div>
    )
  }
}
